import React from 'react';
import NestedFilterPanel from '@client/components/search/NestedFilterPanel';
import Agronomic from '@client/feature/treatment/components/Search/Filters/Agronomic';
import Health from '@client/feature/treatment/components/Search/Filters/Health';
import Environment from '@client/feature/treatment/components/Search/Filters/Environment';
import {
  AGRONOMIC_FILTER_CONFIGS,
  HEALTH_FILTER_CONFIGS,
  ENVIRONMENT_FILTER_CONFIGS,
} from '@client/feature/treatment/config/filterConfigs';
import UpIcon from '../../../../../../img/collapse-icon-up.svg';

const ExtraFilters = ({ filters, onFilterChange, aggregations }) => {
  const countSelections = (filterKeys) => {
    return filterKeys.reduce((count, key) => {
      const value = filters[key];
      if (Array.isArray(value) && value.length > 0) {
        return count + value.length;
      }
      return count;
    }, 0);
  };

  const sections = [
    {
      key: '1',
      labelKey: 'treatment-search|Agronomic',
      Component: Agronomic,
      filterKeys: AGRONOMIC_FILTER_CONFIGS.map((c) => c.key),
    },
    {
      key: '2',
      labelKey: 'treatment-search|Health',
      Component: Health,
      filterKeys: HEALTH_FILTER_CONFIGS.map((c) => c.key),
    },
    {
      key: '3',
      labelKey: 'treatment-search|Environment',
      Component: Environment,
      filterKeys: ENVIRONMENT_FILTER_CONFIGS.map((c) => c.key),
    },
  ];

  const expandIcon = ({ isActive }) => (
    <img
      src={UpIcon}
      alt="Toggle"
      style={{
        width: '24px',
        height: '24px',
        transition: 'transform 0.3s ease',
        transform: isActive ? 'rotate(0deg)' : 'rotate(180deg)',
      }}
    />
  );

  return (
    <NestedFilterPanel
      sections={sections}
      filters={filters}
      onFilterChange={onFilterChange}
      expandIcon={expandIcon}
      countSelections={countSelections}
      aggregations={aggregations}
    />
  );
};

export default ExtraFilters;
